// GameStorage: cross-environment (browser localStorage / Node file) state persistence
const isBrowser = typeof window !== 'undefined' && !!window.localStorage;
const KEY = 'cmdgame:state:v1';
const NODE_FILE = '.cmdgame_state.json';

const DEFAULT = {
  version: 1,
  state: {
    name: '',
    isNamed: false,
    sect: '无名门派',
    level: 1,
    xp: 0,
    qi: 100,
    maxQi: 100,
    location: '洞府',
    bag: [],
    skills: {}
  }
};

class GameStorage {
  constructor() {
    this.key = KEY;
    this.version = 1;
    this.listeners = [];
    this.autosave = true;
  }

  // obtain fs in Node env without giving webpack a static require to analyze
  _getFs() {
    if (isBrowser) return null;
    try {
      return Function('return require')('fs');
    } catch (e) {
      return null;
    }
  }

  _readRaw() {
    if (isBrowser) {
      const raw = window.localStorage.getItem(this.key);
      return raw ? JSON.parse(raw) : null;
    }
    // Node fallback: read from file in project root
    try {
      const fs = this._getFs();
      if (!fs) return null;
      if (!fs.existsSync(NODE_FILE)) return null;
      const raw = fs.readFileSync(NODE_FILE, 'utf8');
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  _writeRaw(obj) {
    if (isBrowser) {
      window.localStorage.setItem(this.key, JSON.stringify(obj));
      return;
    }
    try {
      const fs = this._getFs();
      if (!fs) return;
      fs.writeFileSync(NODE_FILE, JSON.stringify(obj, null, 2), 'utf8');
    } catch (e) {
      // ignore
    }
  }

  loadState() {
    const raw = this._readRaw();
    if (!raw) return null;
    // could implement migrations here
    let state = raw.version && raw.state ? raw.state : raw;
    // ensure bag is always an object {itemName: count}
    if (Array.isArray(state.bag)) {
      const obj = {};
      state.bag.forEach(item => {
        if (typeof item === 'string') {
          obj[item] = (obj[item] || 0) + 1;
        }
      });
      state.bag = obj;
    }
    return state;
  }

  saveState(state) {
    try {
      const obj = { version: this.version, state };
      this._writeRaw(obj);
      this._notify();
      return true;
    } catch (e) {
      return false;
    }
  }

  clear() {
    if (isBrowser) {
      window.localStorage.removeItem(this.key);
    } else {
      try { const fs = this._getFs(); if (fs && fs.existsSync(NODE_FILE)) fs.unlinkSync(NODE_FILE); } catch(e){}
    }
    this._notify();
  }

  exportState() {
    const raw = this._readRaw();
    return raw ? JSON.stringify(raw, null, 2) : JSON.stringify(DEFAULT, null, 2);
  }

  importState(text) {
    try {
      const obj = JSON.parse(text);
      // validate minimal shape
      if (!obj.state) throw new Error('invalid import');
      this._writeRaw(obj);
      this._notify();
      return obj.state;
    } catch (e) {
      throw e;
    }
  }

  subscribe(fn) {
    this.listeners.push(fn);
    return () => { this.listeners = this.listeners.filter(f => f !== fn); };
  }

  _notify() {
    this.listeners.forEach(fn => {
      try { fn(); } catch (e) {}
    });
  }
}

export default new GameStorage();
